import { render, staticRenderFns } from "./PlantCode.vue?vue&type=template&id=3bd5ec87"
import script from "./PlantCode.vue?vue&type=script&lang=js"
export * from "./PlantCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports